module.exports = __webpack_public_path__ + "img/pt-box4-text-dark.6ea298ee.png";